// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__zylNX","title":"ClientReferral_title__1UmI-","itemText":"ClientReferral_itemText__3fytS"};